export enum ConfirmationDialogs {
  ADD_VERSION,
  BACK_VERSIONS,
  CANCEL,
  CANCEL_MASSIVE,
  CANCEL_MASSIVE_TOTS,
  CANCEL_PROCEDURE,
  CANCEL_PROCEDURE_CHANGE_OWNERSHIP,
  CLOSE_PROCEDURE,
  CANCEL_PENDING_CHANGES,
  CHANGE_CLIENT,
  CHANGE_COMMODITY,
  CHANGE_VIEW_DISCARD,
  CHANGE_PRICETYPE,
  CHANGE_COMPANY_LOSE_CHANGES,
  DELETE,
  DELETE_COMMISSION,
  DELETE_COMMERCIAL,
  DELETE_CONTACT,
  DELETE_MASSIVE,
  DELETE_MASSIVE_TOTS,
  DELETE_OBJECTION,
  DELETE_PRICE,
  DELETE_PRICEVALUE,
  DELETE_PERIOD_PRICEVALUE,
  DELETE_TRACT,
  DELETE_VERSION,
  DELETE_PRICECOMPONENT,
  DELETE_FLEXIBILITY,
  DELETE_SETTLEMENTGROUP_CONTRACT,
  DELETE_SETTLEMENTGROUP_SUBJECT,
  DELETE_SETTLEMENTGROUP_CHILD,
  DISCARD_CHANGES,
  GAP_OVERLAP,
  GAP_FUTURE,
  GAP_PAST,
  GAP_BOTH,
  GENERATE_REPORT,
  GO_TO_PROCEDURES,
  GO_TO_PROCEDURES_TERMINATION,
  GO_TO_PROCEDURES_SUSPEND,
  LOCK,
  NONE,
  OVERLAP_FUTURE,
  OVERLAP_PAST,
  OVERLAP_BOTH,
  RECALCULATE_CALCULATEDINDEX,
  SAVE_DATA_TIMED_OUT,
  SAVE_VERSIONS,
  SHOW_TRACTS,
  SEND,
  SEND_MASSIVE,
  SEND_MASSIVE_TOTS,
  SEND_REMIT,
  UNLOCK,
  VERSION_STARTDATE_INVALID,
  VALIDATE_VERSION,
  CHANGE_CONTRACT_OWNER,
  SEND_TANK_MASSIVE,
  SEND_TANKS_MASSIVE,
  SEND_TANK_NO_ORDER_NUMBER,
  PRODUCT_DISABLE,
  PRODUCT_ENABLE,
  CONTRACT_CAPACITIES_MASSIVE_CHANGE,
  GENERATE_INVOICE,
  DELETE_ANNEXED_CONTRACT,
  PUBLISH_QUOTE_DATE_WARNING,
  PUBLISH_QUOTE_VALID_DATE,
  UNDO_QUOTE_PRICELIST_MANUAL_EDIT,
  DELETE_PRODUCT_PRICE_COMPONENT,
  DELETE_PRICECOMPONENT_DEFAULT_VALUE,
  DELETE_PRICE_COMPONENT_TYPE,
  WITHDRAWAL_PROCEDURE,
  NULL_PRICE_VALUE,
  GENERATE_MASSIVE_REMIT_REPORT,
  TERMINATE_OBJECTION,
  DELETE_QUOTE_CONTRACT,
  DELETE_CONCEPT_MODIFIED,
  DELETE_CONCEPT_PRICE,
  DELETE_CONCEPT_RELATED,
  DELETE_INVOICE_CONCEPT,
  INVOICE_CYCLE_INVOICE_ALL,
  INVOICE_CYCLE_INVOICE_WITHOUT_OBJECTIONS,
  INVOICE_CYCLE_INVOICE_WITH_OBJECTIONS,
  INVOICE_CYCLE_CUSTOM_SELECTION,
  INVOICE_CYCLE_ISSUE_ALL,
  INVOICE_CYCLE_ISSUE_WITH_OBJECTIONS,
  INVOICE_CYCLE_ISSUE_WITHOUT_OBJECTIONS,
  INVOICE_CYCLE_ISSUE_WITH_DATE_RANGE,
  INVOICE_CYCLE_ISSUE_CUSTOM_SELECTION,
  INVOICE_CYCLE_ISSUE_ALREADY_ISSUED,
  INVOICE_CYCLE_REGENERATE_EXECUTION_CYCLE,
  INVOICE_CYCLE_REGENERATE_SETTLEMENTS_INVOICES,
  INVOICE_CYCLE_REPAINT_INVOICES,
  INVOICE_CYCLE_REJECT_INVOICES,
  INVOICE_CYCLE_REVERT_DISCARDED_INVOICES,
  INVOICE_CYCLE_ACTIVE_ANNULMENT_CYCLE,
  EVALUATE_LEAD,
  PUBLISH_LEAD,
  DELETE_LEAD,
  DELETE_PROFILE,
  DELETE_QUOTE,
  DEACTIVATE_QUOTE,
  MOVE_QUOTE_TO_HISTORIC,
  ANNULATE_INVOICES,
  REINVOICE_INVOICES,
  ADD_ATLAS_SUPERUSER,
  REMOVE_ATLAS_SUPERUSER_PERMISSION,
  DEACTIVATE_ATLAS_USER,
  DELETE_FLOATING_CONCEPTS,
  CONFIRM_PROCEDURE_CNAE
}
